export default __webpack_public_path__ + "media/images/steps/left-side-trail-d036fec8bbab89cced227e5755f2e1a7.svg";